// removed by extract-text-webpack-plugin
module.exports = {"container":"src-templates----blog-post-module---container---3EKsY","flex":"src-templates----blog-post-module---flex---g2WK2","date":"src-templates----blog-post-module---date---3Uhz3"};


//////////////////
// WEBPACK FOOTER
// ./src/templates/blog-post.module.css
// module id = 341
// module chunks = 107818501498521